import api from '@/api/api';

const DOMAIN = '/password';

const adminSetCompanyPassword = async (
	body: Passwords.SetCompanyPassword,
): Promise<Passwords.AdminSetPasswordResponse> => {
	const payload: Passwords.AdminSetPasswordBody = {
		entityType: 'company',
		entityId: body.companyId,
		newPassword: body.newPassword,
	};
	const { data } = await api.post<Passwords.AdminSetPasswordResponse>(
		`${DOMAIN}/admin`,
		payload,
	);
	return data;
};

const PasswordService = {
	adminSetCompanyPassword,
};

export { PasswordService };
